import Loading from '../../../../../components/general/loadings/loading';
import { Grid } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { Accordion } from '../../../../../components/general/accordion';
import { AlertsNotificationsProps } from './props';
import { useAlertsNotifications } from './hook';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const AlertsNotifications = ({
    alert,
    loading,
}: AlertsNotificationsProps) => {
    const { formik } = useAlertsNotifications(alert);

    return loading ? (
        <Loading />
    ) : (
        <Accordion
            title="NOTIFICACIÓN"
            icon={<MarkEmailReadIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Alerta por correo"
                        checked={Boolean(formik.values.alertByMail)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Activo"
                        checked={Boolean(formik.values.active)}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
